var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide"},[_c('button',[_c('a',{attrs:{"href":_vm.pdf,"download":_vm.pdf,"target":"_blank"}},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" 操作指南")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }